import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      alerts: {
        ALERTS_LIST: 'Alert List',
        ALERT_SETTINGS: 'Alert Settings',
        COMPANY: 'Company',
        INDUSTRY: 'Industry',
        SEARCH_COMPANY_PLACEHOLDER: 'Enter company name, tax code or ticker',
        SEARCH_INDUSTRY_PLACEHOLDER: 'Enter VSIC name or VSIC Code',
        TOTAL_ALERTS: 'Total Alerts',
        UNREAD_ALERTS: 'Unread Alerts',
        TOTAL_NEGATIVE_ALERTS: 'Total Negative Alerts',
        UNREAD_NEGATIVE_ALERTS: 'Unread Negative Alerts',
        ALL: 'All',
        READ_OR_UNREAD: 'Read Or Unread',
        READ: 'Read',
        UNREAD: 'Unread',
        SUBJECT_TYPE: 'Subject Type',
        SENTIMENTS: 'Sentiments',
        sentimentType: {
          POSITIVE: 'Positive',
          NEGATIVE: 'Negative',
          INFORMATIVE: 'Informative',
        },
        subjectType: {
          COMPANY: 'Company',
          INDUSTRY: 'Industry',
          MACROECONOMIC: 'Macroeconomic',
        },
        TIME_PERIOD: 'Time Period',
        timePeriod: {
          ALL: 'All Time (Past 1 year)',
          PAST_30_DAYS: 'Past 30 days',
          PAST_90_DAYS: 'Past 90 days',
          PAST_6_MONTHS: 'Past 6 months',
          CUSTOM: 'Custom Date Ranges',
        },
        EVENTS: 'Events',
        SCORE: 'Score',
        FINANCIAL: 'Financial',
        SUBJECT: 'Subject',
        TYPE_DESCRIPTION: 'Type/ Description',
        DATE: 'Date',
        TRIGGER: 'Trigger',
        NO_ALERT_TO_DISPLAY: 'No alert to display.',
        DELETE_ALERT_TITLE: 'Delete',
        DELETE_ALERT_MESS:
          'Are you sure you want to permanently delete this alert?',
        DELETE_ALERT_MESS_LIST:
          'Are you sure you want to permanently delete %{count} alert%{suffix}?',
        ITEM_SELECTED_COUNT: '%{count} item%{suffix} selected',
        MARK_AS_READ: 'Mask as Read',
        MARK_AS_UNREAD: 'Mask as Unread',
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      alerts: {
        ALERTS_LIST: 'Danh Sách Cảnh Báo',
        ALERT_SETTINGS: 'Cài Đặt Cảnh Báo',
        COMPANY: 'Công Ty',
        INDUSTRY: 'Ngành',
        SEARCH_COMPANY_PLACEHOLDER:
          'Nhập tên công ty, mã số thuế hoặc mã chứng khoán',
        SEARCH_INDUSTRY_PLACEHOLDER: 'Nhập tên ngành VSIC hoặc mã VSIC',
        TOTAL_ALERTS: 'Tổng Cảnh Báo',
        UNREAD_ALERTS: 'Cảnh Báo Chưa Đọc',
        TOTAL_NEGATIVE_ALERTS: 'Tổng Cảnh Báo Tiêu Cực',
        UNREAD_NEGATIVE_ALERTS: 'Cảnh Báo Tiêu Cực Chưa Đọc',
        ALL: 'Tất cả',
        READ_OR_UNREAD: 'Đọc, Chưa Đọc',
        READ: 'Đọc',
        UNREAD: 'Chưa đọc',
        SUBJECT_TYPE: 'Loại Đối Tượng',
        SENTIMENTS: 'Trạng Thái',
        sentimentType: {
          POSITIVE: 'Tích cực',
          NEGATIVE: 'Tiêu cực',
          INFORMATIVE: 'Nhiều thông tin',
        },
        subjectType: {
          COMPANY: 'Công ty',
          INDUSTRY: 'Ngành',
          MACROECONOMIC: 'Kinh tế vĩ mô',
        },
        TIME_PERIOD: 'Thời gian',
        timePeriod: {
          ALL: 'Tất cả (1 năm qua)',
          PAST_30_DAYS: '30 ngày qua',
          PAST_90_DAYS: '90 ngày qua',
          PAST_6_MONTHS: '6 tháng qua',
          CUSTOM: 'Tùy chỉnh thời gian ',
        },
        EVENTS: 'Sự Kiện',
        SCORE: 'Điểm',
        FINANCIAL: 'Chỉ số tài chính',
        SUBJECT: 'Đối Tượng',
        TYPE_DESCRIPTION: 'Phân Loại/ Mô Tả',
        DATE: 'Ngày',
        TRIGGER: 'Tập Cảnh Báo',
        NO_ALERT_TO_DISPLAY: 'Không có cảnh báo phù hợp.',
        DELETE_ALERT_TITLE: 'Xóa cảnh báo',
        DELETE_ALERT_MESS: 'Bạn có muốn xóa vĩnh viễn cảnh báo này không?',
        DELETE_ALERT_MESS_LIST: 'Bạn muốn xóa %{count} cảnh báo?',
        ITEM_SELECTED_COUNT: '%{count} mục đã chọn',
        MARK_AS_READ: 'Đánh dấu đã đọc',
        MARK_AS_UNREAD: 'Đánh dấu chưa đọc',
      },
    },
  }),
)
